enum SoundType {
    RUN = "RUN",
    WALK = "WALK",
    AMBIENT = "AMBIENT",
    CLICK = "CLICK",
    NOTIFICATION = "NOTIFICATION",
    TELEPORT = "TELEPORT",
    PAGE = "PAGE",
    BOOK = "BOOK",
    SPARKLE = "SPARKLE"
}

export default SoundType;
